import script from "./CustomURLField.vue?vue&type=script&setup=true&lang=js"
export * from "./CustomURLField.vue?vue&type=script&setup=true&lang=js"

export default script